import React from 'react';
import styled from 'styled-components';

const StyledEmptyState = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-size: 18px;
    background: #F5F7FB;
    border-radius: 8px;

    p {
        margin: 8px 0;
    }
`;

const EmptyState = ({message, suggestion}) => {
    return (
        <StyledEmptyState>
            <p>{message || 'Файлы не найдены.'}</p>
            {suggestion && <p>{suggestion}</p>}
        </StyledEmptyState>
    );
};

export default EmptyState;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/EmptyState.jsx